new Swiper('.reviews__swiper', {
  speed: 400,
  spaceBetween: 20,
  loop: true,

  breakpoints: {
    320: { slidesPerView: 1 },
    560: { slidesPerView: 2 },
    1280: { slidesPerView: 4 },
  },

  navigation: {
    nextEl: '.reviews__swiper-next',
    prevEl: '.reviews__swiper-prev',
  },

  pagination: {
    el: '.reviews__swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
});
